import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Appointment } from '../schemas/shared';
import useApi from './useApi';

export const useAppointmentByIdQuery = (appointmentId?: number): UseQueryResult<Appointment | null> => {
  const { Api } = useApi();

  return useQuery({
    queryKey: ['appointment', appointmentId],
    queryFn: async () => {
      const response = await Api.booking.getAppointmentList({ appt_id: appointmentId });

      return response?.data?.appointments?.[0] || null;
    },
    enabled: !!appointmentId
  });
};

export default useAppointmentByIdQuery;
